import { Box, Skeleton } from "@mui/material";

interface TableSkeletonProps {
  rows?: number;
  cols?: number;
  rowHeight?: number;
}

const COL_WIDTHS = ["30%", "20%", "15%", "15%", "12%", "8%"];

export default function TableSkeleton({ rows = 5, cols = 4, rowHeight = 52 }: TableSkeletonProps) {
  return (
    <Box sx={{ width: "100%", px: 1 }}>
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <Box
          key={rowIdx}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            height: rowHeight,
            borderBottom: "1px solid",
            borderColor: "divider",
            py: 1,
          }}
        >
          {Array.from({ length: cols }).map((_, colIdx) => (
            <Skeleton
              key={colIdx}
              variant="text"
              animation="wave"
              sx={{
                flex: `0 0 ${COL_WIDTHS[colIdx] ?? "10%"}`,
                height: 20,
                borderRadius: "6px",
              }}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
}
